/**
 *
 * @returns number in compact format STRINGIFIED
 *
 * @example
 *
 * "GenZification" of a number
 *
 * formatNumber(1000) // 1k+
 * formatNumber(52_345) // 52k+
 * formatNumber(1000_000) // 1m+
 *
 */
export function compactNumber(num: number, toFixed = 0): string {
  if (num >= 1e6) return `${(num / 1e6).toFixed(toFixed)}m+`;
  if (num >= 1e3) return `${(num / 1e3).toFixed(toFixed)}k+`;
  return String(num);
}
